import { MemberEdit } from 'ui/components/agent/patterns/MemberEdit/MemberEdit';

/**
 * 仲介業者メンバー編集
 */
export const AgentMemberEdit: React.FC = () => {
    return <MemberEdit />;
};
